module.exports = __webpack_public_path__ + "static/media/uploadFile.e53a9078.svg";